function isMyScriptLoaded(url: string): boolean {
    const scripts = document.getElementsByTagName('script');
    for (let i = scripts.length; i--;) {
        if (scripts[i].src === url) return true;
    }
    return false;
}

export default async function loadExternalScript(url: string, callback?: () => void): Promise<void> {
    if (!isMyScriptLoaded(url)) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const script: any = document.createElement('script');
        script.type = 'text/javascript';

        if (script.readyState) { // IE
            script.onreadystatechange = () => {
                if (script.readyState === 'loaded' || script.readyState === 'complete') {
                    script.onreadystatechange = null;

                    if (callback) {
                        callback();
                    }
                }
            };
        } else {
            script.onload = () => {
                if (callback) {
                    callback();
                }
            };
        }

        script.src = url;
        document.body.appendChild(script);
    }
}
